
(() => {
  const init = () => {
    const video=document.querySelector('[data-swl-video]');
    if(!video || video.dataset.initialized) return;
    video.dataset.initialized='true';
    const motion=matchMedia('(prefers-reduced-motion: reduce)'), connection=navigator.connection;
    const toggle=document.querySelector('[data-swl-toggle]');
    let loaded=false, visible=false, manuallyPaused=false;
    const allowed=()=>!motion.matches && !connection?.saveData && !['slow-2g','2g'].includes(connection?.effectiveType);
    const sync=()=>{if(toggle){toggle.textContent=video.paused?'Film abspielen':'Film pausieren';toggle.setAttribute('aria-label',toggle.textContent);toggle.setAttribute('aria-pressed',String(!video.paused));}};
    const start=()=>{
      if(!allowed() || !visible || document.hidden || manuallyPaused){video.pause();if(!allowed()){video.classList.remove('is-ready');if(toggle)toggle.hidden=true;}return;}
      if(!loaded){[['webm','video/webm'],['mp4','video/mp4']].forEach(([key,type])=>{if(video.dataset[key]){const source=document.createElement('source');source.src=video.dataset[key];source.type=type;video.append(source);}});video.muted=true;video.load();loaded=true;}
      video.play().catch(()=>{if(toggle){toggle.hidden=false;sync();}});
    };
    video.addEventListener('playing',()=>{video.classList.add('is-ready');if(toggle)toggle.hidden=false;sync();});
    video.addEventListener('pause',sync);
    video.addEventListener('error',()=>{video.classList.remove('is-ready');if(toggle)toggle.hidden=true;});
    video.addEventListener('play',()=>{if(!allowed())video.pause();});
    if(toggle)toggle.addEventListener('click',()=>{manuallyPaused=!video.paused;if(manuallyPaused)video.pause();else start();sync();});
    motion.addEventListener('change',start);connection?.addEventListener('change',start);
    document.addEventListener('visibilitychange',start);
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{visible=entry.isIntersecting;start();}),{threshold:.15});
    const ready=()=>observer.observe(video.parentElement);
    if(document.readyState==='complete')ready();else window.addEventListener('load',ready,{once:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
